











import {ChartDataTemplate, FCConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {getLocationCaption} from "@/data/sources/appraisal"
import {executeQuery} from "@/data/repos/query";
import appConfig from "@/config";
import {formatNumberWithGrouping} from "@/data/sources/numbers";


export function config(): WidgetDefinition {
    return {
      ...WConfTpl.Bar2D(),
      widget: "Areas",
      title: "Areas",
      _description: "Areas",
      params: {
        locationId: {...WParamTpl.locationId(), _order: 1},
      },
      fusionChartParams: {
      },
    }
  }

  function getChartConfig() {
    return reactive(FCConfTpl())
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        caption: 'Area, Sq.m',
        // rotatelabels: '1',
        // setadaptiveymin: '1',
        showLegend: '0',
        labelDisplay: '$label , $value',
        showLabels: '1',
        showValues: '1',
        formatNumberScale: "0",
        paletteColors: "#201F7A,#4A47EB,#A3B8F5,#93A329,#C6D65C,#EAF5A3,#999999,#CCCCCC,#E6E6E6",
      // legendCaption: 'Rooms',
        bgColor: "#FFFFFF",
      },
    )
  }

  export default defineComponent({
    props: {
      config: Object,
    },
    components: {
      FusionChartWidget,
    },
    setup(props, context) {
      context.emit("config-update", config())

      let savedChartDataConfig
      async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
        if (config) {
          savedChartDataConfig = chartDataConfig
          chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId)
        }
      }

      async function dataFetcher(params: any): Promise<{ data: any[] }> {
        const data = await executeQuery(
            "idr",
            "eric.areas", {
              locationId: parseInt(params.locationId.value),
              cpId: 1693 /* todo */
            });
        // console.info("Areas:", data)
        const totalArea = data.reduce((sum, item) => sum + item.roomarea, 0)
        if (savedChartDataConfig)
          savedChartDataConfig.caption = "Area: " + formatNumberWithGrouping(totalArea) + " Sq.m"
        return {
          // [{"classification":"Unassigned area","roomarea":503690.2200,"roomcount":28139}]
          data: data.map(item => {
            return {
              label: item.classification,
              value: item.roomarea,
              color: item.classification === "Unassigned area" ? "#FF0000" : undefined
            }
          }),
        }
      }

      function dataplotClickCallback(label: string, val: any) {
        const iprUrl = appConfig.IPR_BASE_URL
        const locationId = props.config.params.locationId.value
        window.open(iprUrl + `/pages/eric_site.asp?id=${locationId}&return=site_details.aspx?id=${locationId}`)
        console.log("chartClickCallback", label, val)
      }

      return {dataFetcher, getChartDataConfig, dataplotClickCallback, configChangeCallback}
    },
  })
